export const UPDATE_INVESTMENT_BENEFIT = 'UPDATE_INVESTMENT_BENEFIT'
export const updateInvestmentBenefit = (investmentBenefit) => ({
  type: UPDATE_INVESTMENT_BENEFIT,
  payload: investmentBenefit,
})
